<template>
  <div class="container-custom">
    <!-- BreadScrumbs -->
    <BreadScrumbs
      :links="[{ name: 'Support Page', to: { path: '/support-page' } }]"
    ></BreadScrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Support Page</h2>
      <v-spacer></v-spacer>
    </div>
    <!--  -->
    <SupportTable class="mb-5"></SupportTable>

    <!-- Support Page Title -->
    <div class="page-actions">
      <h2>Support PageTitle</h2>
      <v-spacer></v-spacer>
      <button @click="toEditSupportPageTitle" class="btn">
        <v-icon>edit</v-icon>
        <span class="pl-2">編輯</span>
      </button>
    </div>
    <div class="block" v-if="pageTitle != null">
      <!-- PageTitle -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>PageTitle</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <div>{{ pageTitle.title }}</div>
        </div>
      </div>
      <!-- Background -->
      <div class="form-item d-flex py-5" v-if="false">
        <div class="w-240px mr-5">
          <h4>Background</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <div
            class="w-480px h-76px bg-cover bg-center"
            :style="{
              'background-image': `url(${pageTitle.image||background})`,
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BreadScrumbs from '@/components/Breadscrumbs.vue';
import SupportTable from '@/views/G_Support/c/SupportTable.vue';

export default {
  components: {
    BreadScrumbs,
    SupportTable,
  },
  data: () => ({
    background: 'https://dummyimage.com/480x76.jpg',
  }),
  computed: {
    ...mapState('pageTitle', ['pageTitle']),
  },
  created() {
    this.clear();
    this.supportClear();
    this.getBus();
    this.getPageTitle('support');
  },
  methods: {
    ...mapActions('support', {
      supportClear: 'clear',
    }),
    ...mapActions('bupage', {
      clear: 'clear',
      getBus: 'find',
    }),
    ...mapActions('pageTitle', {
      getPageTitle: 'findByType',
    }),
    toEditSupportPageTitle() {
      this.$router.push('/support-page/edit-support-page-title');
    },
  },
};
</script>

<style></style>
